$(function() {


    (function() {
        var contactUsModal = $('#ContactUs');
        contactUsModal
            .on('show.bs.modal', function () {
                var successRelatedElements = contactUsModal.find('[data-success-view]');
                successRelatedElements.filter('[data-success-view="true"]').addClass('hidden');
                successRelatedElements.filter('[data-success-view="false"]').removeClass('hidden');
                var errorRelatedElements = contactUsModal.find('[data-error-view]');
                errorRelatedElements.filter('[data-error-view="true"]').addClass('hidden');
                errorRelatedElements.filter('[data-error-view="false"]').removeClass('hidden');
            })
            .on('submit', 'form', function(e) {
                e.preventDefault();
                var self = $(this);

                if (validateContactUs(self)) {
                    var fullName = self.find('#FullNameInput').val();
                    var email = self.find('#EmailInput').val();
                    var subject = self.find('#SubjectInput').val();
                    var msg = self.find('#MessageTextarea').val();
                    $.ajax({
                        url: ajaxContactUsUrl,
                        data: {
                            fullName: fullName,
                            email: email,
                            subject: subject,
                            msg: msg
                        },
                        type: 'POST',
                        dataType: 'json'
                    }).done(function (data) {
                        var successRelatedElements = contactUsModal.find('[data-success-view]');
                        successRelatedElements.filter('[data-success-view="true"]').removeClass('hidden');
                        successRelatedElements.filter('[data-success-view="false"]').addClass('hidden');
                    }).fail(function (data) {
                        var errors = data.responseJSON;
                        var errorText = errors.error || '';
                        $('#errorReason').text(errorText);
                        var errorRelatedElements = contactUsModal.find('[data-error-view]');
                        errorRelatedElements.filter('[data-error-view="true"]').removeClass('hidden');
                        errorRelatedElements.filter('[data-error-view="false"]').addClass('hidden');

                        console.error('Posts could not be loaded.');
                    });
                }
            })
            .on('click', '#retry', function() {
                contactUsModal.modal('show');
            });
    })();


})

function validateContactUs(dataContainer) {
    var errors = {
        emailEmpty: { text: 'Email field can not be empty' },
        invalidEmail: { text: 'Invalid email' },
        msgEmpty: { text: 'Message field can not be empty' }
    };

    var valid = true;
    var email = dataContainer.find('#EmailInput');
    var emailContainer = email.parent();
    var emailErrorBlock = emailContainer.find('.help-block');
    var msg = dataContainer.find('#MessageTextarea');
    var msgContainer = msg.parent();
    var msgErrorBlock = msgContainer.find('.help-block');

    dataContainer.find('.has-error').removeClass('has-error').find('.help-block').addClass('hidden');

    if ($.trim(email.val()) == '') {
        emailContainer.addClass('has-error');
        emailErrorBlock.text(errors.emailEmpty.text).removeClass('hidden');
        valid = false;
        return valid;
    }

    if (!validateEmail(email.val())) {
        emailContainer.addClass('has-error');
        emailErrorBlock.text(errors.invalidEmail.text).removeClass('hidden');
        valid = false;
        return valid;
    }

    if ($.trim(msg.val()) == '') {
        msgContainer.addClass('has-error');
        msgErrorBlock.text(errors.msgEmpty.text).removeClass('hidden');
        valid = false;
        return valid;
    }

    return valid;
}

function validateEmail(email) {
    var emailReg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return emailReg.test(email);
}



//////////////////
// WEBPACK FOOTER
// ./resources/themes/pandax/bobtail/old_scripts/general.js
// module id = 538
// module chunks = 0